import React from 'react';

interface SectionHeaderProps {
  title: string;
  icon?: React.ReactNode;
  color?: string;
}

export function SectionHeader({ title, icon, color = 'text-gray-600' }: SectionHeaderProps) {
  return (
    <h5 className={`m-0 mb-3 text-sm font-semibold ${color} uppercase tracking-wider flex items-center gap-2`}>
      {icon && <span className="text-lg flex items-center">{icon}</span>}
      {title}
    </h5>
  );
}
